<template>
  <section>
    <the-admin-nav-bar
      :value="activeTab"
      @tabChanged="updateTab"
    ></the-admin-nav-bar>

    <div class="has-text-left container" style="padding: 0px 0px 100px 0px">
      <campaign-editor v-if="activeTab == 'Campaign'"></campaign-editor>
      <add-user v-if="activeTab == 'AddUser'"></add-user>
      <risk-editor v-if="activeTab == 'Risk'"></risk-editor>
      <div v-if="activeTab == 'Query'">
        <b-field grouped>
          <b-field label="id number">
            <b-input size="is-small" type="text" v-model.trim="idNumber"
          /></b-field>
          <b-field label="campaign code">
            <b-input size="is-small" type="text" v-model.trim="campaign"
          /></b-field>
          <b-field>
            <b-button
              outlined
              type="is-primary"
              @click="checkAndLoad"
              size="is-small"
              style="margin-top: 30px"
              rounded
              >query</b-button
            ></b-field
          >
          <b-field>
            <b-button
              outlined
              type="is-primary"
              @click="exportSelectedCSV"
              size="is-small"
              style="margin-top: 30px"
              rounded
              >export selected to csv</b-button
            >
          </b-field>
          <b-field>
            <b-button
              outlined
              type="is-primary"
              @click="exportAllCSV"
              size="is-small"
              style="margin-top: 30px"
              rounded
              >export all records to csv</b-button
            ></b-field
          >
        </b-field>
        <b-table
          :data="userDetails"
          :columns="columns"
          :sticky-header="stickyHeaders"
          height="auto"
          size="is-small"
          :loading="isLoading"
          :checked-rows.sync="checkedRows"
          :narrowed="true"
          :paginated="true"
          checkable
          sticky-checkbox
        ></b-table>
      </div>
    </div>
  </section>
</template>

<script>
import { QueryService } from "../../services/query.service";
import TheAdminNavBar from "../ui/TheAdminNavBar.vue";
import RiskEditor from "../admin/RiskEditor.vue";
import CampaignEditor from "../admin/CampaignEditor.vue";
import AddUser from "../admin/AddUser.vue";

export default {
  components: { TheAdminNavBar, RiskEditor, CampaignEditor, AddUser },

  data() {
    return {
      activeTab: "Query",
      age: null,
      idNumber: null,
      campaign: null,
      isLoading: false,
      checkedRows: [],
      allReferenceNumbers: [],
      userDetails: [], //this will store userObjects from the database in an array
      columns: [
        {
          field: "reference_num",
          label: "Ref",
          width: "10",
          headerClass: "is-sticky-column-one",
          cellClass: "is-sticky-column-one",
        },
        { field: "fullname", label: "Name", sticky: true, width: "150" },
        { field: "id_number", label: "ID" },
        { field: "cellphone", label: "Cell Phone" },
        { field: "date_of_completion", label: "Date of Completion" },
        { field: "dob_string", label: "Date of birth" },
        { field: "age", label: "Age" },
        { field: "gender", label: "Gender" },
        { field: "campaign_code", label: "Campaign" },
        { field: "contact_consent", label: "Contact Consent" },
        {
          field: "currently_pregnant",
          label: "Currently Pregnant",
        },
        {
          field: "numbers glucoseRiskcat",
          label: "Glucose Risk Category",
        },
        { field: "numbers hba1cRiskcat", label: "HbA1c Risk Category" },
        {
          field: "numbers cholesterolRiskcat",
          label: "Cholesterol Risk Category",
        },
        { field: "numbers bmiRiskcat", label: "BMI Risk Category" },
        { field: "numbers bpRiskcat", label: "BP Risk Category" },
        { field: "cardio_data risk_cat", label: "Cardio Risk Category" },
        {
          field: "hypertension_data risk_cat",
          label: "Hypertension Risk Category",
        },
        { field: "diabetes_data risk_cat", label: "Diabetes Risk Category" },
        {
          field: "colorectal_cancer_data risk_cat",
          label: "Colorectal Cancer Risk Category",
        },
        {
          field: "breast_cancer_data risk_cat",
          label: "Breast Cancer Risk Category",
        },
        {
          field: "cervical_cancer_data risk_cat",
          label: "Cervical Cancer Risk Category",
        },
        {
          field: "prostate_cancer_data risk_cat",
          label: "Prostate Cancer Risk Category",
        },
        { field: "hiv_data risk_cat", label: "HIV Risk Category" },
        { field: "tb_data risk_cat", label: "TB Risk Category" },
        { field: "sti_data risk_cat", label: "STI Risk Category" },
        {
          field: "mental_health_data risk_cat",
          label: "Mental Health Risk Category",
        },
      ],
      stickyHeaders: true,
    };
  },
  methods: {
    updateTab(tabValue) {
      this.activeTab = tabValue;
    },

    async exportCSV(reference_numbers) {
      this.warningToast(
        "Formatting and fetching data from server, this may take a while.",
        5000
      );
      try {
        this.isLoading = true;
        let res = await QueryService.get_CSV(reference_numbers);
        var csv = res.data.csv;
        // var adhocCvs = res.data.adhoc
        this.saveCsvFile("hra_user_data.csv", csv);
        // this.saveCsvFile("hra_adhoc_data.csv",adhocCvs)
        this.successToast("CSV exported successfully", 3000);
        this.isLoading = false;
      } catch (error) {
        console.error("Error exporting CSV:", error);
        this.errorToast("Failed to export CSV. Please try again.", 3000);
        this.isLoading = false;
      } finally {
        this.isLoading = false;
        this.checkedRows = [];
      }
    },

    async exportAllCSV() {
      this.exportCSV(this.allReferenceNumbers);
    },
    async exportSelectedCSV() {
      if (this.checkedRows.length == 0) {
        this.errorToast("please select records to export");
      } else {
        let referenceNumbers = this.checkedRows.map((row) => row.reference_num);
        this.exportCSV(referenceNumbers);
      }
    },

    saveCsvFile(filename, csv) {
      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    checkAndLoad() {
      this.userDetails = [];
      if (this.campaign != "" && this.idNumber != "")
        this.load(this.idNumber, this.campaign);
      else if (this.idNumber == "") this.load(null, this.campaign);
      else if (this.campaign == "") this.load(this.idNumber, null);
      else this.load();
    },
    async load(idNum = null, campaign = null) {
      this.isLoading = true;
      QueryService.get_UserDetails(idNum, campaign)
        .then((res) => {
          let data = res.data.data;

          if (data.length == 0) {
            this.errorToast("No records found", 3000);
          }
          // convert json string into json
          data = JSON.parse(data);
          this.allReferenceNumbers = data.map((row) => row.reference_num);

          this.userDetails = data;
          this.isLoading = false;
          this.successToast(res.data.message, 3000);
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    exitAdminPortal() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
